export var SENTRY_RELEASE = "36055254d947bcc9f61dcfd4a31918ebe2281cf8";
